import React from 'react';
import PropTypes from 'prop-types';
import { Col, Row, Switch } from 'antd';
import { ExclamationCircleOutlined, SearchOutlined } from '@ant-design/icons';
import GoogleMapReact from 'google-map-react';
import Marker from '../../Map/Marker';
import styles from '../styles.less';
import Button from '../../Button';
import Input from '../../Input';
import WizardInput from '../../Wizard/Input';

const MapSelectorView = ({
  value,
  classname,
  street,
  changeField,
  t,
  houseNumber,
  city,
  locationCreateMode,
  setLocationCreateMode,
  handleLocationChange,
  onMapPositionChange,
}) => (
  <WizardInput
    title={t('course.create.wizard.step7.location.text')}
    hint={t('wizard.hint.location')}
  >
    <div>
      <div className={styles.inputContainer}>
        <Row className={`${styles.row} ${styles.mapWizardInputs}`}>
          <div className={styles.wrapper}>
            <Col className={styles.col} md={15} sm={15} span={15}>
              <div className={styles.validationStatus}>
                {!street && (
                  <span className={styles.red}>{t('school.edit.location.street.validation')}</span>
                )}
                {!street && <ExclamationCircleOutlined className={styles.red} />}
              </div>
              <Input
                version="long"
                size="large"
                value={value && value.street}
                onChange={s => {
                  changeField('street', s.target.value);
                }}
                placeholder={t('school.edit.location.street.placeholder')}
              />
            </Col>
            <Col className={styles.col} md={7} sm={7} span={7}>
              <div className={styles.validationStatus}>
                {!houseNumber && (
                  <span className={styles.red}>
                    {t('school.edit.location.house_number.validation')}
                  </span>
                )}
                {!houseNumber && <ExclamationCircleOutlined className={styles.red} />}
              </div>
              <Input
                version="short"
                size="large"
                value={value && value.house_number}
                onChange={hn => {
                  changeField('house_number', hn.target.value);
                }}
                placeholder={t('school.edit.location.house_number.placeholder')}
              />
            </Col>
          </div>
          <div className={styles.wrapper}>
            <Col className={styles.col} md={7} sm={7} span={7}>
              <Input
                version="short"
                size="large"
                value={value && value.zip_code}
                onChange={s => {
                  changeField('zip_code', s.target.value);
                }}
                placeholder={t('school.edit.location.zipCode.placeholder')}
              />
            </Col>
            <Col className={`${styles.col} ${styles.city}`} md={15} sm={15} span={15}>
              <div className={styles.validationStatus}>
                {!city && (
                  <span className={styles.red}>{t('school.edit.location.city.validation')}</span>
                )}
                {!city && <ExclamationCircleOutlined className={styles.red} />}
              </div>
              <Input
                version="long"
                size="large"
                value={value && value.city}
                onChange={c => {
                  changeField('city', c.target.value);
                }}
                placeholder={t('school.edit.location.city.placeholder')}
              />
            </Col>
          </div>
        </Row>
      </div>
      <div className={styles.customizeContainer}>
        <div>
          <span className={styles.customize}>{t('school.edit.location.customize')}</span>
          <Switch
            defaultChecked={false}
            checked={locationCreateMode}
            onChange={() => {
              setLocationCreateMode(!locationCreateMode);
            }}
          />
        </div>
        <Button
          version="large"
          type="primary"
          onClick={() => {
            let { street: initialStreet } = value;

            if (!(initialStreet.search('Street') >= 0)) {
              initialStreet += ' Street';
            }

            handleLocationChange(
              `${value.city || ''} ${initialStreet || ''} ${value.house_number || ''}`,
            );
          }}
          className={styles.findButton}
          name="wizard_find_button"
        >
          <SearchOutlined />
          {t('school.edit.location.find')}
        </Button>
      </div>
      <div className={styles[classname]}>
        <div className={styles.mapPinter}>
          <Marker lat={parseFloat(value.lat)} lng={parseFloat(value.lng)} />
        </div>
        <GoogleMapReact
          bootstrapURLKeys={{
            key: process.env.GOOGLE_MAPS_API_KEY,
            language: 'en',
          }}
          defaultCenter={{
            lat: parseFloat(value.lat),
            lng: parseFloat(value.lng)
          }}
          defaultZoom={14}
          center={{
            lat: parseFloat(value.lat),
            lng: parseFloat(value.lng)
          }}
          onChange={onMapPositionChange}
        />
      </div>
    </div>
  </WizardInput>
);

MapSelectorView.propTypes = {
  value: PropTypes.object,
  classname: PropTypes.string,
  street: PropTypes.bool,
  changeField: PropTypes.func,
  t: PropTypes.func,
  houseNumber: PropTypes.bool,
  city: PropTypes.bool,
  locationCreateMode: PropTypes.bool.isRequired,
  setLocationCreateMode: PropTypes.func,
  handleLocationChange: PropTypes.func,
  onMapPositionChange: PropTypes.func,
};

MapSelectorView.defaultProps = {
  value: {},
  classname: 'map',
  street: false,
  changeField: () => { },
  t: () => { },
  houseNumber: false,
  city: false,
  setLocationCreateMode: () => { },
  handleLocationChange: () => { },
  onMapPositionChange: () => { },
};

export default MapSelectorView;
